/**
 * A synchronous string key/value store with Web Storage semantics. Inject the abstract token; the
 * active platform module binds it to a concrete implementation (e.g.
 * {@link LocalStorageSyncKeyValueStorageService} for web and the Electron renderer).
 *
 * Exists for the few values that must be readable **before the first paint** (app-shell preferences
 * such as pane widths) and therefore cannot live in the async {@link RegularStorageService}. Anything
 * that tolerates an async read belongs there instead.
 *
 * Like the Web Storage API it mirrors, `setItem` may throw (quota, private mode) — callers decide
 * whether a failed write is worth reporting.
 */
export abstract class SyncKeyValueStorageService {
  abstract getItem(key: string): string | null;
  abstract setItem(key: string, value: string): void;
  abstract removeItem(key: string): void;
}
